module.exports = __webpack_public_path__ + "static/black_and_white_circles-bf2b28a73076bfcd038f619f35757f25.png";